// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"11b2d9bd","129":"979e79b8","225":"05ebb1b8","395":"24e19e27","669":"149165a2","902":"5df72d12","947":"35fbde86"}[chunkId] + ".chunk.css";
};